<div class="dialog-container">
  <div class="dialog-header">
      <mat-icon [ngClass]="data.icon">{{ data.icon || 'help_outline' }}</mat-icon>
      <h2>{{ data.title || 'Confirmación' }}</h2>
      <div style="margin-left:auto;">
        <button mat-icon-button (click)="showHelp()" matTooltip="Ayuda" aria-label="Ayuda diálogo">
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>
  </div>

  <div class="dialog-message">
    <p>{{ data.message || '¿Estás seguro de continuar?' }}</p>
  </div>

  <div class="dialog-actions">
    <button mat-stroked-button color="primary" (click)="onCancel()" style="color: #172C41;">
      {{ data.cancelText || 'Cancelar' }}
    </button>

    <button mat-flat-button color="accent" (click)="onConfirm()" style="background-color: #172C41;">
      {{ data.confirmText || 'Confirmar' }}
    </button>
  </div>
</div>
